// src/components/TotpRing.jsx
//
// A 30-second countdown ring drawn as an inline SVG. The arc depletes from
// full to empty over 30s, then snaps back. No animation library — the
// stroke-dashoffset transitions via CSS over the remaining seconds.

import { useTotpClock } from "../lib/totpClock.js";

const PERIOD = 30;
const SIZE = 36;
const STROKE = 2.5;
const RADIUS = (SIZE - STROKE) / 2;
const CIRC = 2 * Math.PI * RADIUS;

export default function TotpRing() {
  const left = useTotpClock();
  const filled = left / PERIOD;
  const offset = CIRC * (1 - filled);
  return (
    <div
      className="flex items-center gap-2 select-none"
      aria-label={`2FA code refreshes in ${left} seconds`}
      title={`Refreshes in ${left}s`}
    >
      <svg width={SIZE} height={SIZE} className="-rotate-90">
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE}
          className="text-aught-line"
        />
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE}
          strokeLinecap="round"
          strokeDasharray={CIRC}
          strokeDashoffset={offset}
          className="text-aught-oxide transition-[stroke-dashoffset] duration-1000 ease-linear"
        />
      </svg>
      <span className="font-mono tabular text-[11px] text-aught-ash">
        {String(left).padStart(2, "0")}s
      </span>
    </div>
  );
}
